import { useMutation } from '@apollo/client'
import { useEffect, useState } from 'react'
import { EDIT_PAYEES_MUTATION } from '../../graphql/mutation/payees/payees_edit.graphql'
import { getGraphQLAPIErrors } from '../../utils/servicesUtils'

export const useEditService = () => {
  const [errorObj, setErrorObj] = useState(null)
  const [
    loadApi,
    {
      called = true,
      loading: gqlLoading = true,
      error: gqlError = null,
      data: gqlData = null
    }
  ] = useMutation(EDIT_PAYEES_MUTATION, {
    onError: ({ graphQLErrors, networkError }) => {
      getGraphQLAPIErrors({ graphQLErrors, networkError, setErrorObj })
    }
  })

  /**
   * when apollo client updates gqlData, gqlLoading or gqlError
   * trigger subsquent action or data processing.
   * for example: triggering routing change or clean up data
   */
  useEffect(() => {
    if (gqlData?.paymentsDashboard?.paymentsDashboard?.payees?.length > 0) {
      const event = new CustomEvent('billpay-route', {
        detail: {
          action: 'redirect',
          path: 'payeemanagement-billpay/payees/dashboard'
        }
      })

      document?.dispatchEvent(event)
    }
  }, [gqlData, gqlLoading, gqlError])

  return {
    loadApi,
    called,
    loading: gqlLoading,
    data: gqlData,
    error: errorObj
  }
}
export default useEditService
